import React from "react";

// ADSTERRA COMPONENT PLACEHOLDER
// Non-intrusive, labelled layout container reserved for an Adsterra native/banner ad.
// Replace the inner block with the live Adsterra ad tag when ready — keep the outer
// wrapper so spacing/layout stays stable. Pass width/height (px) for fixed ad formats
// (e.g. 728x90, 300x250); it stays responsive via maxWidth:100%.
export const AdSlot = ({ id, label = "Advertisement", width, height, className = "" }) => {
  const style = width
    ? { width, height, maxWidth: "100%", minHeight: height }
    : undefined;
  return (
    <div
      id={id}
      data-testid={`ad-slot-${id}`}
      aria-hidden="true"
      style={style}
      className={`adsterra-slot mx-auto ${width ? "" : "w-full max-w-3xl min-h-[90px]"} rounded-xl border border-dashed border-stone-300 bg-stone-50/60 flex items-center justify-center text-stone-400 text-[11px] tracking-[0.2em] uppercase select-none ${className}`}
    >
      {/* ADSTERRA COMPONENT PLACEHOLDER — replace this block with your Adsterra ad tag */}
      {label}
    </div>
  );
};

export default AdSlot;
